var React = require('react');

function TitleBlockDownArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-142.44 -135.67)"},React.createElement("g",{"transform":"matrix(.26458 0 0 .26458 122.17 114.63)"},React.createElement("g",{"transform":"translate(76.578,79.5)","data-name":"Сгруппировать 168220"},React.createElement("path",{"transform":"translate(-25.635,-6.5)","d":"m56.886 52.976 8.714-29.048h-18.658l4.066-17.428h-16.167l-9.206 30.688h21.386l-6.316 15.788h-9.341l9.577 25.539 25.538-25.539zm-23.156 1.64h8.086l7.627-19.069h-21.603l8.222-27.407h12.88l-4.067 17.429h18.525l-8.718 29.047h7.838l-20.938 20.936z","fill":"#deeded","data-name":"Контур 337291"})))));
}

TitleBlockDownArrow.defaultProps = {"width":"10.807mm","height":"19.054mm","version":"1.1","viewBox":"0 0 10.807 19.054"};

module.exports = TitleBlockDownArrow;

TitleBlockDownArrow.default = TitleBlockDownArrow;
